import React, { useState } from 'react';
import Header from "../../../commons/Header/Header";
import Footer from "../../../commons/Footer/Footer";
import Accordion from 'react-bootstrap/Accordion';
import faqs from './faqs';
// Removed GLobalLinks
const FaqAgents = (props) => {
  const [activeKey, setActiveKey] = useState("0-0");
  const faqsdata = Object.values(faqs);
  return (
    <>
      <Header en="/partner/faq-agents" fr="/fr" lang="en" />
      <div className="container mainDiv faqsagents">
        <div className="row">
          <div className="col-xs-12 content">
            <h1 className="forms">FAQ Agents</h1>
            <div>
              <div className="row">
                <div className="col-lg-8">
                  {
                    faqsdata.map((item,i)=>{
                      return(
                        <div key={i}>
                          <h2>{item.title}</h2>
                          <Accordion activeKey={activeKey} onSelect={(e) => setActiveKey(e)}>
                          {
                            item.accordian.map((accord,j)=>{
                              const eventKey = `${i}-${j}`;
                              return(
                                <Accordion.Item eventKey={eventKey} key={eventKey} id={eventKey} className={activeKey === `${eventKey}` ? `${eventKey} show` : `${eventKey}`}>
                                  <Accordion.Header>{accord.title}</Accordion.Header>
                                  <Accordion.Body dangerouslySetInnerHTML={{__html:accord.body}} >
                                  </Accordion.Body>
                                </Accordion.Item>
                              )
                            })
                          }
                          </Accordion>
                        </div>
                      );
                    })
                  }
                </div>
                <div className="col-lg-4">
                  <div className="stickyDiv">
                    <div className="holder_block">
                      <h2>Quick Links</h2>
                      <ul className="list">
                        <li><a href="/products/trips/">TRIPs</a></li>
                        <li><a href="/products/visitors-canada-insurance/">VTC Plans</a></li>
                        <li><a href="/products/student-accident-plan/">SAP</a></li>
                        <li><a href="/products/international-student/">ISP</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer lang="en" />
    </>
  );
}

export default FaqAgents;
